import React from 'react';
import SectionContact from "./Contact.styled";
import {Color} from "../Common/Colors";
import H2 from "../Common/H2.styled";
import Container from "../Common/Container.styled";
import StyledContactGrid from "./ContactGrid.styled";
import Form from "./Form/Form";


const Contact = () => {

    return (
        <SectionContact id="contact" backgroundColor={Color.lavender}>
            <H2>Contact</H2>
            <Container>
                <StyledContactGrid>
                    <div className="contact_form-wrapper">
                        <Form id="email-form" name="email-form" data-name="Email Form" method="get"
                              className="contact_form">
                        </Form>
                    </div>
                    <div className="contact_wrapper">
                        <div className="contact_info">
                            <a href="https://www.google.com/maps/place/New+Richmond,+WI+54017/" target="_blank"
                               className="contact_link-block">
                                <div className="contact_solid-icon fa-solid fa-location-dot"/>
                            </a>
                            <div className="contact_text-block">
                                <div className="contact_title">Address</div>
                                <div className="contact_title-info">New Richmond, WI</div>
                            </div>
                        </div>
                        <div className="contact_info">
                            <a href="tel:7155634454" className="contact_link-block">
                                <div className="contact_solid-icon fa-solid fa-mobile-screen-button"/>
                            </a>
                            <div className="contact_text-block">
                                <div className="contact_title">Phone</div>
                                <div className="contact_title-info">715-563-4454</div>
                            </div>
                        </div>
                        <div className="contact_info">
                            <a href="mailto:kevin.effertz@gmail.com" className="contact_link-block">
                                <div className="contact_solid-icon fa-solid fa-envelope"/>
                            </a>
                            <div className="contact_text-block">
                                <div className="contact_title">Email</div>
                                <div className="contact_title-info">kevin.effertz@gmail.com</div>
                            </div>
                        </div>
                        <div className="contact_info">
                            <a href="http://www.linkedin.com/in/kevin-effertz"
                               className="contact_link-block w-inline-block">
                                <div className="contact-brand-icon fa-brands fa-linkedin"/>
                            </a>
                            <div className="contact_text-block">
                                <div className="contact_title">LinkedIn</div>
                                <div className="contact_title-info">linkedin.com/in/kevin-effertz</div>
                            </div>
                        </div>
                    </div>
                </StyledContactGrid>
            </Container>
        </SectionContact>
    )
}

export default Contact;

